import { isEmpty, reduce, uniq } from "lodash";

import { definitionActionTypes } from "../../../definition";
import { colorActionTypes } from "../../../definition/colors";
import { actionTypes as itemActionTypes } from "../../../items/actions";
import rootActionTypes from "../../../rootActionTypes";
import { getAffectedActionIds } from "./getIdsFromActions";

const individualActionTypes = [
  //#!if readonly !== true
// itemActionTypes.EDIT_COLOR,
// itemActionTypes.EDIT_LABEL,
// itemActionTypes.SET_SUPER,
// itemActionTypes.DELETE_ITEMS,
// itemActionTypes.CREATE_ITEM
  //#!endif
];

const globalActionTypes = [
  //#!if readonly !== true
// colorActionTypes.CHANGE_COLOR,
// colorActionTypes.DELETE_COLOR,
  //#!endif
  definitionActionTypes.REPLACE_DEFINITIONS,
  rootActionTypes.LOAD_FILE,
  rootActionTypes.UPDATE_FILE,
  rootActionTypes.LOAD_SAMPLE
];

// Changes:
//   - superLabel
//   - superColor
const applySuperUpdates = (state, action, newSuperAndChildrenById, prevSuperAndChildrenById) => {
  let { affectedIds, matchedIndividual } = getAffectedActionIds(
    state,
    action,
    globalActionTypes,
    individualActionTypes
  );

  if (matchedIndividual) {
    // Pull out all of the affected ids from this set of actions
    // Items are affected if they have changed, or if their children have changed
    const additionalIds = uniq(
      reduce(
        affectedIds,
        (result, aId) => {
          // Add its immediate children, since we will be updating its super
          const newSuperAndChildren = newSuperAndChildrenById.get(aId);
          if (newSuperAndChildren) {
            result.push(...newSuperAndChildren.children.toArray());
          }
          // Repeat for old values also, since we need to update any children
          // of a deleted item also
          const prevSuperAndChildren = prevSuperAndChildrenById.get(aId);
          if (prevSuperAndChildren) {
            result.push(...prevSuperAndChildren.children.toArray());
          }
          return result;
        },
        []
      )
    );
    affectedIds = uniq([...affectedIds, ...additionalIds]);
  }

  if (affectedIds.length === 0) {
    return state;
  }

  return state.withMutations(s => {
    affectedIds.forEach(cId => {
      const superAndChildren = newSuperAndChildrenById.get(cId);
      const itemRec = state.get(cId);
      if (!itemRec) {
        return;
      }
      let changes = {};
      if (superAndChildren && superAndChildren.super) {
        const superRec = state.get(superAndChildren.super);
        if (superRec.label !== itemRec.superLabel) {
          changes.superLabel = superRec.label;
        }
        if (superRec.color !== itemRec.superColor) {
          changes.superColor = superRec.color;
        }
      } else {
        if (itemRec.superLabel !== null) {
          changes.superLabel = null;
        }
        if (itemRec.superColor !== null) {
          changes.superColor = null;
        }
      }
      if (!isEmpty(changes)) {
        s.update(cId, d => d.merge(changes));
      }
    });
  });
};

export default applySuperUpdates;
